import cc from "classcat";

import styles from "./ShareIcon.module.scss";

const ShareIcon = () => {
  return (
    <div className={styles.shareIconContainer}>
      <span
        className={cc([
          "narmi-icon-link",
          styles.shareIcon,
          styles.shareIconBottomLayer,
        ])}
      />
      <span
        className={cc([
          "narmi-icon-link",
          styles.shareIcon,
          styles.shareIconTopLayer,
        ])}
      />
    </div>
  );
};

export default ShareIcon;
